/* Colibre product stage: swipe, variants, add to cart. Used by sections/colibre-product-stage.liquid */
(function () {
  if (customElements.get('colibre-stage')) return;
  var reduceMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  class ColibreStage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-stage-slide]'));
      this.infos = Array.from(this.querySelectorAll('[data-info-slide]'));
      this.count = this.slides.length;
      this.index = Math.min(Number(this.dataset.start) || 0, Math.max(this.count - 1, 0));
      this.productMode = this.hasAttribute('data-product-mode');
      this.stage = this.querySelector('[data-stage]');
      this.imgTrack = this.querySelector('[data-img-track]');
      this.infoTrack = this.querySelector('[data-info-track]');
      this.queueItems = Array.from(this.querySelectorAll('[data-queue-item]'));
      this.counter = this.querySelector('[data-counter]');
      this.live = this.querySelector('[data-live]');
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (this.count < 2) { prev.hidden = true; next.hidden = true; }
      prev.addEventListener('click', () => this.go(this.index - 1));
      next.addEventListener('click', () => this.go(this.index + 1));
      this.queueItems.forEach((q) => q.addEventListener('click', () => this.go(Number(q.dataset.index))));
      this.addEventListener('keydown', (e) => {
        if (e.target.closest('input, select, textarea')) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      });
      this.initDrag();
      this.infos.forEach((info, k) => this.initInfo(info, k));
      this.render(false);
    }

    go(i) {
      if (this.count < 2) return;
      var target = (i + this.count) % this.count;
      if (target === this.index) { this.render(false); return; }
      this.index = target;
      this.render(true);
      if (this.productMode) this.syncProduct();
    }

    setX(pct) {
      var t = 'translate3d(' + pct + '%, 0, 0)';
      this.imgTrack.style.transform = t;
      this.infoTrack.style.transform = t;
    }

    render(animate) {
      var moving = animate && !reduceMotion();
      if (moving) this.classList.add('is-moving');
      this.setX(-100 * this.index);
      [this.slides, this.infos].forEach((list) => list.forEach((el, k) => {
        var on = k === this.index;
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
        el.inert = !on;
      }));
      if (this.counter) {
        var pad = function (n) { return String(n).padStart(2, '0'); };
        this.counter.textContent = pad(this.index + 1) + ' / ' + pad(this.count);
      }
      var depth = Math.min(3, this.count - 1);
      this.queueItems.forEach((q) => { q.hidden = true; q.removeAttribute('data-depth'); q.style.order = ''; });
      for (var k = 1; k <= depth; k++) {
        var q = this.queueItems[(this.index + k) % this.count];
        if (!q) continue;
        q.hidden = false; q.dataset.depth = k; q.style.order = String(4 - k);
      }
      if (animate && this.live) this.live.textContent = (this.infos[this.index] && this.infos[this.index].dataset.title) || '';
      clearTimeout(this._t);
      if (moving) this._t = setTimeout(() => this.classList.remove('is-moving'), 520);
    }

    initDrag() {
      var stage = this.stage;
      var x0 = 0, y0 = 0, dx = 0, w = 1, active = false, axis = null, pid = null;
      stage.addEventListener('pointerdown', (e) => {
        if (this.count < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
        if (e.target.closest('button')) return;
        active = true; axis = null; dx = 0; x0 = e.clientX; y0 = e.clientY; pid = e.pointerId;
        w = stage.clientWidth || 1;
      });
      stage.addEventListener('pointermove', (e) => {
        if (!active || e.pointerId !== pid) return;
        dx = e.clientX - x0;
        var dy = e.clientY - y0;
        if (axis === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis !== 'x') { active = false; return; }
          try { stage.setPointerCapture(pid); } catch (err) {}
          this.classList.add('is-dragging');
        }
        e.preventDefault();
        var edge = (this.index === 0 && dx > 0) || (this.index === this.count - 1 && dx < 0);
        var d = edge ? dx * 0.4 : dx;
        this.setX(-100 * this.index + (d / w) * 100);
      }, { passive: false });
      var end = (e) => {
        if (!active || e.pointerId !== pid) return;
        active = false;
        if (axis !== 'x') return;
        this.classList.remove('is-dragging');
        this._noClick = true;
        setTimeout(() => { this._noClick = false; }, 80);
        if (Math.abs(dx) > Math.min(90, w * 0.14)) this.go(this.index + (dx < 0 ? 1 : -1));
        else this.render(false);
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      stage.addEventListener('click', (e) => {
        if (this._noClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      stage.addEventListener('dragstart', (e) => e.preventDefault());
    }

    initInfo(info, k) {
      var data = info.querySelector('[data-variants]');
      var variants = [];
      try { variants = JSON.parse(data ? data.textContent : '[]'); } catch (err) { variants = []; }
      var form = info.querySelector('form');
      var input = info.querySelector('[data-variant-input]');
      var price = info.querySelector('[data-price]');
      var compare = info.querySelector('[data-compare]');
      var btn = info.querySelector('[data-add]');
      var label = info.querySelector('[data-add-label]');
      var groups = Array.from(info.querySelectorAll('[data-option-group]'));
      info._current = variants.find((x) => input && String(x.id) === String(input.value)) || variants[0];
      groups.forEach((g) => g.addEventListener('click', (e) => {
        var b = e.target.closest('[data-value]');
        if (!b) return;
        g.querySelectorAll('[data-value]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        var shown = g.querySelector('[data-opt-value]');
        if (shown) shown.textContent = b.dataset.value;
        var sel = groups.map((gr) => { var p = gr.querySelector('[aria-pressed="true"]'); return p ? p.dataset.value : null; });
        var v = variants.find((vv) => vv.options.every((o, i) => sel[i] === null || o === sel[i]));
        if (!v) { if (btn) btn.disabled = true; if (label) label.textContent = info.dataset.unavailable; return; }
        info._current = v;
        if (input) input.value = v.id;
        if (price) price.textContent = v.price;
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
        if (btn) btn.disabled = !v.available;
        if (label) label.textContent = v.available ? info.dataset.addLabel : info.dataset.soldout;
        this.swapImage(k, v);
        if (this.productMode && k === this.index) {
          try { history.replaceState(history.state, '', info.dataset.url + '?variant=' + v.id); } catch (err) {}
        }
      }));
      if (form && btn) form.addEventListener('submit', (e) => this.addToCart(e, form, info, btn, label));
    }

    swapImage(k, v) {
      if (!v || !v.img) return;
      var slide = this.slides[k];
      var img = slide && slide.querySelector('img');
      if (img && slide.dataset.media !== String(v.media)) {
        slide.dataset.media = String(v.media);
        img.classList.add('is-swapping');
        var done = () => img.classList.remove('is-swapping');
        img.addEventListener('load', done, { once: true });
        setTimeout(done, 600);
        img.removeAttribute('srcset');
        img.src = v.img;
        var q = this.queueItems[k] && this.queueItems[k].querySelector('img');
        if (q && v.thumb) { q.removeAttribute('srcset'); q.src = v.thumb; }
      }
    }

    async addToCart(e, form, info, btn, label) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (btn.disabled || this._adding) return;
      this._adding = true;
      btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      var ids = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
      if (ids.length) fd.append('sections', ids.join(','));
      var routes = (window.Theme && window.Theme.routes) || {};
      var Ev = null;
      try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (err) { Ev = null; }
      var deferred = Ev && Ev.createPromise ? Ev.createPromise() : null;
      if (deferred) {
        this.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: 1 }], promise: deferred.promise }));
      }
      try {
        var res = await fetch(routes.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd });
        var data = await res.json();
        var cart = await fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
        var failed = Boolean(data && data.status);
        if (deferred) {
          deferred.resolve({
            cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : cart,
            detail: { items: cart.items, source: 'colibre-stage', itemCount: 1, productId: info.dataset.productId, sections: failed ? undefined : data.sections, didError: failed },
          });
        }
        if (failed) this.flash(label, data.description || data.message || 'Could not add', info);
        else { this.flash(label, info.dataset.added, info); this.openCart(Boolean(deferred)); }
      } catch (err) {
        if (deferred) deferred.reject(err);
        this._adding = false;
        form.submit();
        return;
      }
      this._adding = false;
      btn.removeAttribute('aria-busy');
    }

    flash(label, text, info) {
      if (!label) return;
      label.textContent = text;
      clearTimeout(info._flash);
      info._flash = setTimeout(() => {
        var v = info._current;
        label.textContent = v && !v.available ? info.dataset.soldout : info.dataset.addLabel;
      }, 1800);
    }

    openCart(viaEvent) {
      var comp = document.querySelector('cart-drawer-component');
      var drawer = comp && comp.closest('theme-drawer');
      if (drawer) {
        setTimeout(() => { if (!drawer.isOpen && typeof drawer.open === 'function') drawer.open(); }, 150);
        return;
      }
      if (!viaEvent) window.location.href = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart');
    }

    syncProduct() {
      var info = this.infos[this.index];
      if (!info || !info.dataset.url) return;
      var v = info._current;
      try { history.replaceState(history.state, '', info.dataset.url + (v ? '?variant=' + v.id : '')); } catch (err) {}
      var shop = this.dataset.shopName || '';
      var t = info.dataset.pageTitle || info.dataset.title || '';
      document.title = shop && t.indexOf(shop) === -1 ? t + ' – ' + shop : t;
      clearTimeout(this._sync);
      this._sync = setTimeout(() => this.refreshSections(info.dataset.url), 450);
    }

    refreshSections(url) {
      var own = this.closest('.shopify-section');
      var ids = Array.from(document.querySelectorAll('main .shopify-section, #MainContent .shopify-section'))
        .filter((s) => s !== own && s.id.indexOf('shopify-section-') === 0 && !s.closest('header, footer'))
        .map((s) => s.id.replace('shopify-section-', ''))
        .slice(0, 5);
      if (!ids.length) return;
      fetch(url + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((map) => {
          var info = this.infos[this.index];
          if (!map || !info || info.dataset.url !== url) return;
          Object.keys(map).forEach((id) => {
            var el = document.getElementById('shopify-section-' + id);
            if (!el || !map[id]) return;
            var doc = new DOMParser().parseFromString(map[id], 'text/html');
            var fresh = doc.getElementById('shopify-section-' + id);
            if (fresh) el.replaceWith(fresh);
          });
        })
        .catch(() => {});
    }
  }

  customElements.define('colibre-stage', ColibreStage);
})();
